<div class="cg-dd" [class.open]="open" [class.up]="up">
  <button type="button" class="cg-dd-trigger" (click)="toggle( $event )"
          [attr.aria-label]="ariaLabel" [attr.aria-expanded]="open">
    <img *ngIf="selected?.icon" class="cg-dd-icon" [src]="selected?.icon" alt="" aria-hidden="true">
    <span class="cg-dd-label" [class.cg-dd-placeholder]="!selectedLabel || value === ''">{{ selectedLabel }}</span>
    <span class="cg-dd-caret" aria-hidden="true"></span>
  </button>

  <ul class="cg-dd-options" *ngIf="open">
    <li *ngFor="let opt of options" class="cg-dd-option"
        [class.active]="opt.value === value" [class.disabled]="opt.disabled"
        (click)="select( opt )">
      <img *ngIf="opt.icon" class="cg-dd-icon" [src]="opt.icon" alt="" aria-hidden="true">
      <span class="cg-dd-option-label">{{ opt.label }}</span>
    </li>
  </ul>
</div>
